import { z } from 'zod';
import { EmptyObject } from 'libs/end-to-end/src/generic';
import { createCustomVizRequestSchema } from 'libs/end-to-end/src/custom-viz/createCustomVizRequestSchema';
import { FilterDefinitionForExtras } from 'libs/end-to-end/src/types/databases/filters/filter-definition';
import { ViewConfigurationSchema } from 'libs/end-to-end/src/view-configurations';

// 1. The request type
export const SummaryStatsInputs = z.object({
  dropdowns: EmptyObject,
  extras: z.object({
    metrics: z.array(z.string()).optional(),
    filters: FilterDefinitionForExtras.array(),
  }),
});

export const SummaryStatsRequest = createCustomVizRequestSchema(
  'summaryStats',
  SummaryStatsInputs,
);

export type SummaryStatsRequest = z.infer<typeof SummaryStatsRequest>;

// 2. The result type
export const SummaryStatsOutput = z
  .object({
    columnHeaders: z.array(z.string()),
    values: z.array(z.string()),
    sampleSizes: z.array(z.number()),
    numerators: z.array(z.number()),
    booleanColumns: z.array(z.string()),
  })
  .describe('SummaryStatsOutput');

export type SummaryStatsOutput = z.infer<typeof SummaryStatsOutput>;

export const SummaryStatsComponentProps = z.object({
  data: SummaryStatsOutput,
  isLoading: z.boolean(),
  viewConfiguration: ViewConfigurationSchema,
});

export type SummaryStatsComponentProps = z.infer<
  typeof SummaryStatsComponentProps
>;
